import { render, staticRenderFns } from "./TableForm13.vue?vue&type=template&id=30c2b190&scoped=true"
import script from "./TableForm13.vue?vue&type=script&lang=ts"
export * from "./TableForm13.vue?vue&type=script&lang=ts"
import style0 from "./TableForm13.vue?vue&type=style&index=0&id=30c2b190&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2b190",
  null
  
)

export default component.exports